module.exports = __webpack_public_path__ + "static/media/arrow-dark-blue.5ab8f038.svg";